// Name Format: Alpha characters, dashes, and apostrophes
export const nameRegex = /^[a-z ,.'-]+$/i;

// Address Format: Alphanumeric characters, dashes, and apostrophes
export const addressRegex = /^[a-z0-9 ,.'-]+$/i;

// City Format: Alpha characters, dashes, and apostrophes
export const cityRegex = /^[a-z ,.'-]+$/i;

// Phone Format: 10 numerals (no leading 1)
export const phoneRegex = /^[0-9]{10}/;

// currency format, whole integers
export const integerRegex = /^[0-9]*$/;

// currency format, whole numbers with exactly zero or two decimal points

export const intergerRegexDecimal = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;

// Zip Format: 5 numerals
export const zipRegex = /^[0-9]{5}$/;

// SSN Format: 222222222 (all numerals, no dashes, checks for invalid patterns)
export const ssnRegex = /^(?!219099999|078051120)(?!666|000|9\d{2})\d{3}(?!00)\d{2}(?!0{4})\d{4}$/;

// Individual ssn block formats
export const ssn1Regex = /^(?!666|000|9\d{2})\d{3}$/; // first three digits cannot be 666, 000, or begin with a 9, and must be 3 numeric digits
export const ssn2Regex = /^(?!00)\d{2}$/; // Middle block cannot be 00 and must be 2 numeric digits
export const ssn3Regex = /^(?!0{4})\d{4}/; // The last four digits cannot start with zero and must be 4 numeric digits

// Format: MM/DD/YYYY, checks for invalid dates including leap days. excludes DOB before 1900
export const dateRegex = /((0[13578]|1[02])[/.]31[/.](19|20)[0-9]{2})|((01|0[3-9]|1[1-2])[/.](29|30)[/.](19|20)[0-9]{2})|((0[1-9]|1[0-2])[/.](0[1-9]|1[0-9]|2[0-8])[/.](19|20)[0-9]{2})|((02)[/.]29[/.](((19|20)(04|08|[2468][048]|[13579][26]))|2000))/;

// Validate email
export const emailRegex = /\S+@\S+\.\S+/;
